import { useState, useEffect } from 'react';

export const useLastSeen = (storageKey = 'lastSeenBookings', maxItems = 10) => {
  const [lastSeen, setLastSeen] = useState([]);

  const readStorage = () => {
    const stored = JSON.parse(localStorage.getItem(storageKey)) || [];
    setLastSeen(stored);
  };

  useEffect(() => {
    readStorage();

    const handleStorageChange = (event) => {
      if (event.key === storageKey) {
        readStorage();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [storageKey]);

  const addLastSeenV1 = (booking) => {
    let current = JSON.parse(localStorage.getItem(storageKey)) || [];
    let updated = [booking, ...current.filter(b => b.id !== booking.id)];
    if (updated.length > maxItems) updated = updated.slice(0, maxItems);

    localStorage.setItem(storageKey, JSON.stringify(updated));
    setLastSeen(updated); // update local state juga
  };

  const addLastSeenV2 = (booking) => {
    let current = JSON.parse(localStorage.getItem(storageKey)) || [];
    let updated = [booking, ...current.filter(b => b.id !== booking.id)];
    if (updated.length > maxItems) updated = updated.slice(0, maxItems);
  
    localStorage.setItem(storageKey, JSON.stringify(updated));
    setLastSeen(updated); // <-- UPDATE React State!
  };

  const addLastSeen = (booking) => {
    setLastSeen((prev) => {
      const updated = [booking, ...prev.filter(b => b.id !== booking.id)].slice(0, maxItems);
      localStorage.setItem(storageKey, JSON.stringify(updated));
      return updated; // 🔥 langsung balikin ke state!
    });
  };
  
  

  const clearLastSeen = () => {
    localStorage.removeItem(storageKey);
    setLastSeen([]);
  };

  return { lastSeen, addLastSeen, clearLastSeen };
};
